"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["data-id"];
const vue_3 = require("vue");
const TabooPattern_vue_1 = __importDefault(require("./TabooPattern.vue"));
const sortablejs_1 = __importDefault(require("sortablejs"));
const taboo_pattern_store_1 = require("../js/stores/taboo_pattern_store");
const sortable_1 = require("../model/v1/sortable");
exports.default = (0, vue_1.defineComponent)({
    __name: 'TabooPatternsTable',
    emits: ["update-pattern-position", "pattern-delete"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const patternTable = (0, vue_3.ref)(null);
        const patternsOrder = (0, vue_3.computed)(() => {
            return taboo_pattern_store_1.store.data.tabooPatternsOrder || [];
        });
        (0, vue_3.onMounted)(() => {
            if (patternTable.value) {
                new sortablejs_1.default(patternTable.value, {
                    ...sortable_1.sortableOptions,
                    onMove: (evt) => {
                        const { related } = evt;
                        return related && related.closest('table') === patternTable.value;
                    },
                    onEnd: () => {
                        const tbodyEl = patternTable?.value?.querySelectorAll('tbody') || [];
                        // Get the new order of keys (ids)
                        const reorderedIds = Array.from(tbodyEl).map((tbody) => {
                            const dataId = tbody.getAttribute('data-id');
                            return dataId || '';
                        });
                        emit('update-pattern-position', reorderedIds);
                    },
                });
            }
        });
        function onPatternDelete(tabooPatternId) {
            emit('pattern-delete', tabooPatternId);
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("table", {
                class: "oplus-table",
                ref_key: "patternTable",
                ref: patternTable
            }, [
                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(patternsOrder.value, (id, index) => {
                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tbody", {
                        class: "draggable",
                        key: id,
                        "data-id": id
                    }, [
                        (0, vue_2.createVNode)(TabooPattern_vue_1.default, {
                            tabooPatternId: id,
                            addBorderTop: index > 0,
                            onPatternDelete: onPatternDelete
                        }, null, 8 /* PROPS */, ["tabooPatternId", "addBorderTop"])
                    ], 8 /* PROPS */, _hoisted_1));
                }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */));
        };
    }
});
